import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { PlatformProvider, AthenaProvider, ThemeProvider } from './contexts';
import { ErrorBoundary } from './components/error';
import { CommonAuthProvider } from './contexts/CommonAuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import AuthValidator from './components/auth/AuthValidator';
import ProductAccessValidator from './components/auth/ProductAccessValidator';
import ToastContainer from './components/ToastContainer';
import ActivateAccount from './pages/ActivateAccount';
import NotFound from './pages/NotFound';

import { projectsRoutes } from './features/projects';
import { athenaRoutes } from './features/athena';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <Router>
          <Routes>
            {/* Public route - no authentication required */}
            <Route path="/activate" element={<ActivateAccount />} />

            {/* Protected routes - require authentication */}
            <Route path="/*" element={
              <CommonAuthProvider>
                <NotificationProvider>
                  <PlatformProvider>
                    <ToastContainer />
                    <AuthValidator>
                      <Routes>
                        <Route path="/dashboard" element={<Navigate to="/projects" replace />} />

                        {projectsRoutes}

                        <Route path="/athena/*" element={
                          <ProductAccessValidator requiredProduct="athena">
                            <AthenaProvider>
                              <Routes>
                                {athenaRoutes}
                                {/* Catch unmatched /athena/* paths (e.g. legacy
                                    URLs retired by DC-001..004 + FU-001 commit 4). */}
                                <Route path="*" element={<NotFound />} />
                              </Routes>
                            </AthenaProvider>
                          </ProductAccessValidator>
                        } />

                        <Route path="/" element={<Navigate to="/projects" replace />} />
                        {/* Top-level catch-all. Unknown paths outside /projects,
                            /project/:projectId, and /athena/* land here.
                            (`/project/:projectId/*` has its own catch-all that
                            falls back to OverviewTab so workspace deep-links
                            stay inside the workspace shell.) */}
                        <Route path="*" element={<NotFound />} />
                      </Routes>
                    </AuthValidator>
                  </PlatformProvider>
                </NotificationProvider>
              </CommonAuthProvider>
            } />
          </Routes>
        </Router>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
